import {
  GreyGrey30,
  GreyGrey60,
  GreyGrey80,
  Primary13SemiBold,
  Flex,
  Grid,
  GridItem
} from '@sequencehq/core-components'
import { useMemo, useState } from 'react'
import { QuoteReviewDiscussion } from './QuoteReviewDiscussion'
import { QuoteReviewSummary } from './QuoteReviewSummary'
import { TaskInput } from '../../types'

type Tabs = 'discussion' | 'summary'
const tabs: Array<{
  id: Tabs
  label: string
  component: React.FC<{ taskInput: TaskInput }>
}> = [
  {
    id: 'discussion',
    label: 'Discussion',
    component: QuoteReviewDiscussion
  },
  {
    id: 'summary',
    label: 'Summary',
    component: QuoteReviewSummary
  }
]

export const QuoteReviewDetails = ({ taskInput }: { taskInput: TaskInput }) => {
  const [activeTabId, setActiveTabId] = useState('discussion')
  const activeTab = useMemo(
    () => tabs.find(tab => tab.id === activeTabId),
    [activeTabId]
  )

  return (
    <Grid templateRows="auto 1fr" overflow="hidden" height="100%" width="406px">
      <GridItem
        display="flex"
        gap="4px"
        padding="0 12px"
        borderBottom={`1px solid ${GreyGrey30}`}
      >
        {tabs.map(tab => (
          <Flex
            height="40px"
            key={tab.id}
            padding="2px 8px 0"
            cursor="pointer"
            borderBottom={
              activeTabId === tab.id
                ? `2px solid ${GreyGrey80}`
                : `2px solid transparent`
            }
            color={activeTabId === tab.id ? GreyGrey80 : GreyGrey60}
            {...Primary13SemiBold}
            transition="border-bottom 0.25s ease-in-out"
            alignItems="center"
            justifyContent="center"
            onClick={() => setActiveTabId(tab.id)}
          >
            {tab.label}
          </Flex>
        ))}
      </GridItem>
      <GridItem>
        {activeTab && <activeTab.component taskInput={taskInput} />}
      </GridItem>
    </Grid>
  )
}
